import {
    Attachment,
    Base64File,
    UploadedDocument
} from '../interface/interface';

export const convertDocumentItemToFile = async (item: any): Promise<File> => {
    const fileName = item.documentName || item.name;
    const fileUrl = item.href;

    const response = await fetch(fileUrl);
    const blob = await response.blob();

    const file = new File([blob], fileName, {
        type: blob.type || 'application/octet-stream',
        lastModified: Date.now()
    });

    // ✅ attach custom metadata
    (file as any).externalReferenceCode = item.externalReferenceCode;
    (file as any).objectEntryId = item.objectEntryId;

    return file;
};

const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.result) {
                resolve(
                    reader.result
                        .toString()
                        .replace('data:', '')
                        .replace(/^.+,/, '')
                );
            } else {
                reject(new Error('Failed to read file.'));
            }
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};
const urlToBase64 = async (url: string): Promise<string> => {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.result) {
                resolve(
                    reader.result
                        .toString()
                        .replace('data:', '')
                        .replace(/^.+,/, '')
                );
            } else {
                reject(new Error('Failed to read blob.'));
            }
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
type ConvertibleFile = File | UploadedDocument;

export const convertFilesToBase64 = async (
    files: ConvertibleFile[]
): Promise<Base64File[]> => {
    const result: Base64File[] = [];

    for (const file of files) {
        try {
            // Case 1: Browser File
            if (file instanceof File) {
                const base64 = await fileToBase64(file);
                result.push({
                    fileBase64: base64,
                    name: file.name
                });
            }
            // Case 2: API file object
            else if ('href' in file && file.href) {
                const base64 = await urlToBase64(file.href);
                result.push({
                    fileBase64: base64,
                    name: file.name
                });
            }
        } catch (error) {
            console.error('Error converting file:', file, error);
        }
    }

    return result;
};
export const processUploadedFiles = async (
    files: ConvertibleFile[],
    objectEntryId: number = 0
): Promise<Attachment[]> => {
    const base64Files = await convertFilesToBase64(files);

    return base64Files.map((file) => ({
        attachment: {
            fileBase64: file.fileBase64,
            name: file.name
        },
        objectEntryId
    }));
};
